import { Paper } from "@material-ui/core";
import { blue, cyan, grey, orange, purple } from "@material-ui/core/colors";
import {
  StyledComponentProps,
  StyleRulesCallback,
  Theme,
  withStyles,
} from "@material-ui/core/styles";
import * as React from "react";
import { connect } from "react-redux";
import { DashboardFilterState } from "src/types";

import { Dispatch, StoreState } from "../store";
import { dashboardFiltersPartiallyEqual, format } from "../utilities";
import PieChart from "./generic/PieChart";

function mapStateToProps({ dashboardFilter, nbaDistribution }: StoreState) {
  return {
    nbaDistribution,
    dashboardFilter,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    fetchNbaDistribution: (dashboardFilter: DashboardFilterState) =>
      dispatch.nbaDistribution.fetchNbaDistribution(dashboardFilter),
  };
}

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

const COLORS = [
  blue[500],
  blue[700],
  blue[900],
  grey[700],
  orange[500],
  cyan[300],
  cyan[900],
  purple[400],
  cyan[600],
  blue[300],
];

class PieChartNba extends React.Component<Props & StyledComponentProps> {
  public componentDidMount() {
    if (this.props.nbaDistribution.nbaTopTen.length === 0) {
      this.props.fetchNbaDistribution(this.props.dashboardFilter);
    }
  }

  public componentDidUpdate(previousProps: Props) {
    if (
      !dashboardFiltersPartiallyEqual(
        previousProps.dashboardFilter,
        this.props.dashboardFilter,
        ["dateRange", "score"]
      )
    ) {
      this.props.fetchNbaDistribution(this.props.dashboardFilter);
    }
  }

  private prepareData = (): Array<{ label: string; value: number }> =>
    this.props.nbaDistribution.nbaTopTen.map((nba) => ({
      ...nba,
      value: parseFloat(nba.value),
    }));

  public render() {
    const { classes } = this.props;
    const dateLabel = format(new Date(), "MMMM yyyy");

    return (
      <Paper className={classes && classes.paper}>
        <PieChart
          id="nba_pie_chart"
          loading={this.props.nbaDistribution.loading}
          title={`Verteilung Top 10 Beratungsfokus für ${dateLabel}`}
          data={this.prepareData()}
          colorScheme={COLORS}
          tooltipFormatter={(v) => `${v}%`}
          showTooltip
        />
      </Paper>
    );
  }
}

const styles: StyleRulesCallback<Theme, Props> = (theme: Theme) => ({
  paper: {
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(4),
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(PieChartNba));



// WEBPACK FOOTER //
// ./src/components/PieChartNba.tsx